<template>
    <div class="location">
        <Header :app="app" :left="true" :right="app.isPermitted(app.user, 'admin')" :title="app.selectedLocation ? app.selectedLocation.name : 'Location'">
            <template v-slot:left>
                <a href="javascript:;" v-on:click="app.$router.push('/')">
                    &laquo;
                </a>
            </template>

            <template v-slot:right>
                <router-link :to="{ name: 'locationEdit', params: { id: app.selectedLocation.id } }">
                    &#9998;
                </router-link>
            </template>
        </Header>

        <div class="content">
            <div class="header no-select">
                <input type="date" v-model="date">
                <span class="clear-q active" v-on:click="q = ''" v-if="q.length">&times;</span>
                <span :class="(showAll ? 'active ' : '') + 'show-all'" v-on:click="showAll = !showAll" v-if="!q.length"><span v-if="showAll">Everyone</span><span v-else>Regulars</span></span>
                <input type="text" v-model="q" placeholder="Search or Add...">
            </div>

            <table class="table pretty">
                <thead>
                    <tr>
                        <th class="has-checkbox">
                            Reg
                        </th>
                        <th class="with-padding align-left">
                            Name
                        </th>
                        <th class="with-padding">
                            Present
                        </th>
                    </tr>
                </thead>

                <tbody>
                    <tr v-for="person in filteredPeople" :key="person.id">
                        <td>
                            <a href="javascript:;" v-on:click="app.star(app.selectedLocation, person)">
                                <span v-if="app.isStarred(app.selectedLocation, person)" class="lock">&#128274;</span>
                                <span v-else>&nbsp;</span>
                            </a>
                        </td>
                        <td class="align-left">
                            <router-link :to="{ name: 'personEdit', params: { id: person.id } }">
                                {{app.personName(person)}}
                            </router-link>
                        </td>
                        <td class="icons">
                            <a href="javascript:;" v-on:click="app.present(app.selectedLocation, person, date)">
                                <span v-if="app.isPresent(app.selectedLocation, person, date)" class="check">&check;</span>
                                <span v-else class="uncheck">&times;</span>
                            </a>
                        </td>
                    </tr>
                    <tr v-if="q.length">
                        <td class="with-padding align-left" colspan="3">
                            <span v-if="q.length">
                                <button v-if="app.sortedPeople.length < 25 || app.isPaid" v-on:click.prevent="app.addPersonByName(app.selectedLocation, q, date, component)">
                                    Add "{{q}}"
                                </button>
                                <a v-else href="https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=29U2LHYQNAURL" target="_blank" class="button">
                                    Upgrade to Add More People!
                                </a>
                            </span>
                        </td>
                    </tr>
                    <tr v-if="!filteredPeople.length">
                        <td class="with-padding align-left" colspan="3">
                            <p class="display-block align-center">
                                <br><br>
                                <span v-if="q.length">
                                    We couldn't find anyone that matches "{{q}}."
                                </span>

                                <span v-else>
                                    Nobody is here!
                                </span>

                                <span v-if="app.sortedPeople.length">
                                    <br><br>

                                    <a href="javascript:;" v-on:click="q = ''; showAll = true" class="button button-gray">
                                        Show Everyone
                                    </a>
                                </span>

                                <br><br>
                            </p>
                        </td>
                    </tr>
                </tbody>

                <tfoot>
                    <tr>
                        <td></td>
                        <td class="with-padding">
                            <strong>Total</strong>
                        </td>
                        <td class="with-padding">{{total}}</td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
</template>

<script>
import Header from '@/components/header/component.vue';

export default {
    name: 'location',
    components: {
        Header
    },
    props: ['app'],
    data() {
        var _ = this,
            d = new Date();

        return {
            q: '',
            component: this,
            date: d.getFullYear() + '-' + _.app.zeroPad(d.getMonth() + 1) + '-' + _.app.zeroPad(d.getDate()),
            transition: undefined,
            showAll: false
        };
    },
    computed: {
        filteredPeople() {
            var _ = this,
                people = _.app.sortedPeople || [],
                location = _.app.selectedLocation,
                q = _.q.toLowerCase();

            if (q && q.length) {
                return people.filter(function(p) {
                    return p.name.toLowerCase().indexOf(q) !== -1;
                });
            } else {
                return people.filter(function(person) {
                    return _.showAll || (
                        location && (
                            location.peopleIds.indexOf(person.id) !== -1 ||
                            _.app.isPresent(location, person, _.date)
                        )
                    );
                });
            }
        },
        total() {
            var _ = this;

            return _.app.sortedPeople.filter(function(person) {
                return _.app.isPresent(_.app.selectedLocation, person, _.date);
            }).length;
        }
    }
};
</script>
